import { render } from "./LikeFiles.vue?vue&type=template&id=556637dc&scoped=true"
import script from "./LikeFiles.vue?vue&type=script&lang=js"
export * from "./LikeFiles.vue?vue&type=script&lang=js"

import "./LikeFiles.vue?vue&type=style&index=0&id=556637dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-556637dc"

export default script